import qs from 'qs'
import { useMemo } from 'react'

import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ISafetyCaseStatus, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  baseStatus?: string
  entityState?: string
  activeOnly?: boolean
}

const getSafetyCaseStatusesRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyCaseStatuses${queryString}`,
  }
}

const useSafetyCaseStatusesQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ISafetyCaseStatus[] | undefined
>({
  getRequest: getSafetyCaseStatusesRequest,
  getQueryKey: (params, queryObject) => [
    'safety-case-statuses',
    queryObject?.baseStatus,
    queryObject?.entityState,
    queryObject?.activeOnly,
  ],
})

const useSafetyCaseStatusesQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ISafetyCaseStatus[] | undefined, Error>,
) => {
  const safetyCaseStatusesQuery = useSafetyCaseStatusesQueryBase(undefined, queryObject, options)

  const defaultItem = useMemo(
    () => (safetyCaseStatusesQuery?.data || []).find(safetyCase => safetyCase.isDefault),
    [safetyCaseStatusesQuery?.data],
  )

  return { ...safetyCaseStatusesQuery, defaultItem }
}
export default useSafetyCaseStatusesQuery
